//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { MOBILE } from '@/scripts/constants/media-query'
export default {
  props: {
    headingTag: {
      type: String,
      default: 'h2',
    },
    theme: {
      type: String,
      default: 'dark', // options: ['dark', 'light']
    },
    textAlign: {
      type: String,
      default: 'center', // options: ['left', 'center', 'right']
    },
    isSearchAvailable: {
      type: Boolean,
      default: false,
    },
    isLayoutHorizontal: {
      type: Boolean,
      // When this is active: textAlign, isSearchAvailable, countdown, ctaMobileOrientation and verticalSpacing should be off
      default: false,
    },
    countdownStart: Number,
    countdownEnd: Number,
    countdownHideIfExpired: {
      type: Boolean,
      default: false,
    },
    countdownFormat: {
      type: String,
      default: '%dd:%hh:%mm:%ss',
    },
    ctaMobileOrientation: {
      type: String,
      default: 'vertical', // options: ['vertical', 'horizontal']
    },
    verticalSpacing: {
      type: String,
      default: 'large', // options: ['large', 'small']
    },
    pillTheme: {
      type: String,
      default: 'trasparent', // options: ['dark', 'light']
    },
    pill: String,
    pillPosition: {
      type: String,
      default: 'center',
    },
    messageColor: {
      type: String,
      default: 'dark',
    },
  },

  computed: {
    modifierClasses() {
      let textAlign = this.isLayoutHorizontal ? 'left' : this.textAlign

      return {
        ['text-module--theme-' + this.theme]: this.theme,
        ['text-module--horizontal-layout']: this.isLayoutHorizontal,
        ['text-module--text-align-' + textAlign]: this.textAlign,
        ['text-module--cta-mobile-orientation-' + this.ctaMobileOrientation]:
          this.ctaMobileOrientation,
        ['text-module--vertical-spacing-' + this.verticalSpacing]: this.verticalSpacing,
      }
    },
    pillModifierClasses() {
      return {
        ['text-module__pill-container--text-align-' + this.pillPosition]: this.pillPosition,
      }
    },
    pillColorClass() {
      if (this.pillTheme != 'trasparent') {
        return this.pillTheme === 'dark' ? 'black' : 'white'
      } else {
        return this.pillTheme
      }
    },
    isPillAvailable() {
      return !!this.pill
    },
    isImageBlockAvailable() {
      return !!this.$slots.image_block
    },

    isImageAvailable() {
      return !!this.$slots.image
    },

    isCountdownAvailable() {
      return !!this.countdownStart && !!this.countdownEnd
    },

    countdownProps() {
      let propsObj = {
        start: this.countdownStart,
        end: this.countdownEnd,
      }

      if (this.countdownHideIfExpired !== undefined)
        propsObj['hideIfExpired'] = this.countdownHideIfExpired
      if (this.countdownHideIfExpired !== undefined) propsObj['format'] = this.countdownFormat

      return propsObj
    },

    isCopyBlockAvailable() {
      return (
        this.isTitleBlockAvailable || this.isExcerptBlockAvailable || this.isSubtitleBlockAvailable
      )
    },

    isCopyAvailable() {
      return this.isTitleAvailable || this.isExcerptAvailable || this.isSubtitleAvailable
    },

    isTitleBlockAvailable() {
      return !!this.$slots.title_block
    },

    isTitleAvailable() {
      return !!this.$slots.title
    },

    isExcerptBlockAvailable() {
      return !!this.$slots.excerpt_block
    },

    isExcerptAvailable() {
      return !!this.$slots.excerpt
    },

    isSubtitleBlockAvailable() {
      return !!this.$slots.subtitle_block
    },

    isSubtitleAvailable() {
      return !!this.$slots.subtitle
    },

    isCtaBlockAvailable() {
      return !!this.$slots.cta_block
    },

    isCtaAvailable() {
      return this.isCta1Available || this.isCta2Available
    },

    isCta1Available() {
      return !!this.$slots.cta_1
    },

    isCta2Available() {
      return !!this.$slots.cta_2
    },
    isMobile() {
      return this.$mq === MOBILE
    },
    isCtaContainerAvailable() {
      return this.isCtaAvailable || this.isCtaBlockAvailable
    },
    isMessageAvailable() {
      return !!this.$slots.message
    },
    textModuleMessageColor() {
      return `text-module__message--${this.messageColor}`
    },
  },
}
